<template>
  <div class="minePage">
    <div class="user_info">
      <div class="user flex-rowl">
        <div class="tx flex-rowc">
          <van-image
            class="img"
            width="98%"
            height="98%"
            round
            :src="
              userInfo.headimg
                ? userInfo.headimg
                : require('../assets/images/user-tx.png')
            "
          />
          <h5-cropper
            class="uploadInput"
            :option="option"
            @getFile="handleChooseImg"
          ></h5-cropper>
          <div class="edit flex-rowc">
            <i class="iconfont icon-zhaoxiangji"></i>
          </div>
        </div>
        <div class="main">
          <div class="nick">
            {{ userInfo.nickname ? userInfo.nickname : "" }}
          </div>
          <div class="name">
            {{ userInfo.truename ? userInfo.truename : "" }}
          </div>
          <div class="leavel_accountId flex-rowl">
            <p>
              {{ userInfo.levelid ? "LV-" + userInfo.levelid : "" }} |
              {{ userInfo.attrname ? userInfo.attrname : "" }}
            </p>
            <p class="accountId">
              ID：{{ userInfo.accountid ? userInfo.accountid : "" }}
            </p>
            <div
              class="copy_box"
              :data-clipboard-text="userInfo.accountid"
              @click="handleCopyBtn"
            >
              <i class="iconfont icon-fuzhi"></i>
            </div>
          </div>
        </div>
      </div>
      <div class="tags flex-rowl">
        <div class="tag flex-rowc user_auth_icon active">买手认证</div>
        <div class="tag flex-rowc company_auth_icon">商家认证</div>
      </div>
    </div>
    <div class="line"></div>
    <div class="userInfo_wrap column_wrap">
      <div class="title flex-between">
        <h1>个人信息</h1>
        <!-- <router-link to="/userIndex" class="edit flex-rowc" -->
        <router-link to="/userIndex" class="flex-rowc"
          ><i class="iconfont icon-edit"></i
        ></router-link>
      </div>
      <div class="base_info_list">
        <div class="base_info_item flex-rowl">
          <div class="txt1 flex-rowc">
            <div class="icon_box flex-rowc">
              <i class="iconfont icon-xingmingyonghumingnicheng"></i>
            </div>
            姓名：
          </div>
          <div class="txt2">{{ userInfo.truename }}</div>
        </div>
        <div class="base_info_item flex-rowl">
          <div class="txt1 flex-rowc">
            <div class="icon_box flex-rowc">
              <i class="iconfont icon-shoujihaoma"></i>
            </div>
            工作手机：
          </div>
          <div class="txt2">{{ tuozhanInfo.mobile }}</div>
        </div>
        <div class="base_info_item flex-rowl">
          <div class="txt1 flex-rowc">
            <div class="icon_box flex-rowc">
              <i class="iconfont icon-weixin"></i>
            </div>
            工作微信：
          </div>
          <div class="txt2">{{ tuozhanInfo.weixin }}</div>
        </div>
        <div class="base_info_item flex-rowl">
          <div class="txt1 flex-rowc">
            <div class="icon_box flex-rowc">
              <i class="iconfont icon-gender"></i>
            </div>
            性别：
          </div>
          <div class="txt2">{{ userInfo.sex ? userInfo.sex : "" }}</div>
        </div>
        <div class="base_info_item flex-rowl">
          <div class="txt1 flex-rowc">
            <div class="icon_box flex-rowc">
              <i class="iconfont icon-nianling"></i>
            </div>
            年龄：
          </div>
          <div class="txt2">{{ userInfo.age ? userInfo.age : "" }}</div>
        </div>
        <div class="base_info_item">
          <div class="txt1 flex-rowl">
            <div class="icon_box flex-rowc">
              <i class="iconfont icon-weibiaoti-3"></i>
            </div>
            所在地区（日常活动范围）
          </div>
          <div class="txt">
            <van-field
              v-model="PCA_address"
              placeholder="省、市、自治区"
              readonly
            />
          </div>
          <div class="txt">
            <van-field
              v-model="userInfo.addr"
              placeholder="区、街道、详细地址"
              readonly
            />
          </div>
        </div>
      </div>
    </div>

    <div class="custom_btn" @click="handleExit">切换账号</div>
  </div>
</template>

<script>
import Clipboard from "clipboard";
import { uploadImage } from "../api/api";
import { updateUserNickTx } from "../api/user";
import { mapState } from "vuex";
import H5Cropper from "vue-cropper-h5";
import storage from '../utils/storage'
export default {
  name: "mine",
  components: { H5Cropper },
  data() {
    return {
      isLoading: true,
      PCA_address: "",
      userInfo: "",
      tuozhanInfo: "",
      userCompanyCard: {},
      cityArea: "",
      checkstate: 0, //0-审核中、1-已通过、2-拒绝加入、3-已退出、4-已被移除

      option: {}, //配置
    };
  },
  computed: {
    ...mapState(["OPENID", "USERINFO", "userAgent"]),
  },
  created() {
    this.getInit();
  },
  methods: {
    async getInit() {
      const toast = this.$toast.loading({
        message: "加载中...",
        forbidClick: true,
      });
      // 获取用户
      this.userInfo = this.USERINFO;
      let res1 = this.USERINFO
      let provincename = res1.provincename ? res1.provincename : " ";
      let cityname = res1.cityname ? res1.cityname : " ";
      let areaname = res1.areaname ? res1.areaname : " ";
      this.PCA_address = provincename + cityname + areaname;
      this.tuozhanInfo = res1.tuozhan[0];

      toast.clear();
      this.isLoading = false;
    },

    // 复制
    handleCopyBtn() {
      let clipboard = new Clipboard(".copy_box");
      clipboard.on("success", () => {
        // console.log("复制成功",e);
        this.$toast.success("复制成功");
        // 释放内存
        clipboard.destroy();
      });
      clipboard.on("error", (e) => {
        // 不支持复制
        console.log("该浏览器不支持自动复制", e);
        if (e.text) {
          this.$toast.fail("复制失败");
        } else {
          this.$toast("暂无内容");
        }
        // 释放内存
        clipboard.destroy();
      });
    },

    // 修改用户头像
    handleUpload() {
      let userInfo = this.$store.state.USERINFO;
      let params = {
        openid: userInfo.openid,
        nickname: userInfo.nickname,
        headimg: userInfo.headimg,
      };
      updateUserNickTx(params).then((res) => {
        console.log(res);
      });
    },
    // 上传图片
    handleChooseImg(data) {
      const toast = this.$toast.loading({
        message: "提交中...",
        forbidClick: true,
      });
      const formData = new FormData();
      formData.append("imgfile", data);
      uploadImage(formData).then((res) => {
        if (res.result) {
          this.userInfo.headimg = res.url;
          toast.clear();
          this.handleUpload();
        } else {
          this.$toast.fail("上传失败");
        }
      });
    },

    // 退出登录
    handleExit() {
      storage.removeAll()
      this.$router.push('/login/1')
    },
  },
};
</script>
<style lang="less" scoped>
.minePage {
  padding-bottom: 280px;
  box-sizing: border-box;
  .icon-edit {
    font-size: 30px;
    color: #333;
  }
  .user_info {
    padding: 45px 0 0;
    margin: auto;
    width: 670px;
    .img {
      position: absolute;
    }
    .tx {
      width: 140px;
      height: 140px;
      border: 5px solid #f0f0f0;
      box-sizing: border-box;
      border-radius: 50%;
      // overflow: hidden;
      margin-right: 25px;
      position: relative;
      .edit {
        position: absolute;
        bottom: 7px;
        right: 9px;
        background: #f0f0f0;
        width: 30px;
        height: 30px;
        border-radius: 50%;
        .iconfont {
          font-size: 12px;
        }
      }
      .uploadInput {
        position: relative;
        z-index: 10000000001;
      }
    }
    .main {
      flex: 1;
      .nick {
        font-size: 22px;
        color: #828282;
      }
      .name {
        font-size: 30px;
        color: #3c3c3c;
        margin: 12px 0 14px;
      }
      .leavel_accountId {
        font-size: 16px;
        color: #aaaaaa;
        .accountId {
          margin: 0 13px 0 45px;
        }
      }
    }
    .tags {
      font-size: 18px;
      color: #fff;
      margin-top: 16px;
      padding-left: 164px;
      box-sizing: border-box;
      .tag {
        width: 160px;
        height: 35px;
        text-align: center;
        line-height: 35px;
        border-radius: 18px;
        background: #bebebe;
        margin-right: 10px;
        &.active {
          background: #ff4200;
        }
      }
      .user_auth_icon::before {
        display: inline-block;
        content: "";
        background: url(../assets/images/user_auth_icon.png) no-repeat center;
        background-size: cover;
        width: 25px;
        height: 20px;
        margin-right: 10px;
      }
      .company_auth_icon::before {
        display: inline-block;
        content: "";
        background: url(../assets/images/company_auth_icon.png) no-repeat center;
        background-size: cover;
        width: 20px;
        height: 20px;
        margin-right: 10px;
      }
    }
  }
  .line {
    background: url(../assets/images/mime_line.png) no-repeat center;
    background-size: cover;
    width: 750px;
    height: 86px;
    margin: 28px 0 60px;
  }
  .company_column {
    width: 670px;
    margin: 60px auto 0;
    .title {
      padding: 0 20px;
      color: #333333;
      font-size: 30px;
      margin-bottom: 36px;
    }
    .card_box {
      width: 100%;
      box-shadow: 0px 0px 16px 0px rgba(10, 1, 3, 0.1);
      border-radius: 50px;
      background: #fff;
      box-sizing: border-box;
      font-size: 28px;
      color: #333333;
      position: relative;
      .no {
        padding: 92px 0;
        .custom_btn {
          width: 310px;
          margin: auto;
          font-size: 22px;
          &:last-child {
            margin-top: 70px;
          }
        }
      }
      .company_wrapper {
        padding: 50px 35px 50px;
        box-sizing: border-box;
        position: relative;
        font-size: 24px;
        .primary-button {
          height: 60px;
          line-height: 60px;
          font-size: 24px;
          margin: 50px auto;
        }
        .company_upper {
          .img_box {
            width: 160px;
            height: 160px;
            margin-right: 30px;
          }
          .intro {
            font-size: 24px;
            color: #333333;
            .row:nth-child(1) {
              margin-bottom: 22px;
            }
            .subTit {
              font-size: 20px;
              color: #969696;
              margin-bottom: 10px;
            }
          }
        }
        .company_content_info,
        .company_down,
        .company_address {
          margin: 50px 0 85px;
          .row {
            margin-bottom: 28px;
            &:last-child {
              margin-bottom: 0;
            }
            .right {
              flex: 1;
              flex-shrink: 0;
            }
            .bottom {
              margin-top: 10px;
            }
            .place {
              width: 100%;
            }
          }
        }
        .certification_state {
          position: absolute;
          top: 20px;
          right: 15px;
          background: #bebebe;
          border-radius: 17px;
          color: #fff;
          font-size: 18px;
          height: 35px;
          line-height: 35px;
          padding: 0 28px 0 21px;
          &::before {
            display: inline-block;
            content: "";
            background: url(../assets/images/company_auth_icon.png) no-repeat
              center;
            background-size: cover;
            width: 20px;
            height: 20px;
          }
          margin-right: 5px;
        }
        .place {
          font-size: 22px;
          color: #969696;
        }
        .operation {
          position: absolute;
          bottom: -20px;
        }
      }
      .custom_btn {
        height: 60px;
        line-height: 60px;
        padding: 0 35px 0 36px;
        box-sizing: border-box;
        width: auto;
        margin-right: 15px;
        .icon-xinjian {
          font-size: 34px;
          margin-left: 7px;
        }
        .icon-xingtuxuetang-jiaru- {
          font-size: 30px;
          margin-left: 7px;
        }
        .icon-tuichu {
          font-size: 24px;
          margin-left: 7px;
          font-weight: bold;
        }
      }
    }
  }
  .column_wrap {
    padding: 30px 0;
    border-bottom: 30px solid #fafafa;
    .btn {
      width: 600px;
      height: 110px;
      border: 1px solid #aaaaaa;
      font-size: 28px;
      color: #333333;
      margin: auto;
      .qy_icon {
        width: 43px;
        height: 35px;
        margin-right: 18px;
      }
      .icon-anquan {
        font-size: 44px;
        margin-right: 20px;
      }
    }
  }
  .userInfo_wrap {
    padding: 29px 55px 0 81px;
    background: #fff;
    box-sizing: border-box;
    font-size: 24px;
    color: #333333;
    .title {
      margin-bottom: 60px;
      h1 {
        font-size: 30px;
        color: #333333;
      }
      .edit {
        padding: 0 20px;
        height: 35px;
        border-radius: 25px;
        background: #373737;
        font-size: 18px;
        color: #fff;
        .icon-edit {
          margin-right: 5px;
          color: #fff;
          // font-size: 20px;
        }
      }
    }
    .base_info_item {
      margin-bottom: 60px;
    }
  }
}
</style>
